import Questions from "questions";
export default function Survey() {
  const {
    intro,
    outro,
    questions
  } = Questions;
  const entries = JSON.parse(JSON.stringify(questions));
  const entryAt = index => entries[index];
  let currentIndex = 0;
  let currentSub = null;
  function getFollowUp() {
    const obj = currentSub ? currentSub : entryAt(currentIndex);
    return "followUp" in obj ? obj.followUp : null;
  }
  function getQuestion() {
    return currentSub ? currentSub.text : entryAt(currentIndex).text;
  }
  function getAnswers() {
    return currentSub ? currentSub.answers : entryAt(currentIndex).answers;
  }
  function setAnswer(answer) {
    if (currentSub) currentSub.answer = answer;else entryAt(currentIndex).answer = answer;
  }
  function gotoNextQuestion() {
    const entry = entryAt(currentIndex);
    if (!currentSub && "sub" in entry && entry.answer in entry.sub) {
      console.log("goto sub");
      currentSub = entry.sub[entry.answer];
    } else {
      currentSub = null;
      currentIndex++;
    }
    return currentSub || hasQuestion();
  }
  function getAllAnswers() {
    return entries;
  }
  function hasQuestion() {
    console.log("hasQuestion", currentIndex, entries.length);
    return currentIndex < entries.length;
  }
  function getCurrentIndex() {
    return currentIndex;
  }
  function getQuestionCount() {
    return entries.length;
  }
  return {
    intro,
    outro,
    getQuestion,
    setAnswer,
    getAnswers,
    getAllAnswers,
    getFollowUp,
    getCurrentIndex,
    getQuestionCount,
    gotoNextQuestion,
    hasQuestion
  };
}